export default function () {
  return {
    current: null,
  };
}
